var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurBlueVan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "M3.35 6.65c-1.055 0-1.9.845-1.9 1.9v7.6h1.9A2.85 2.85 0 0 0 6.2 19a2.85 2.85 0 0 0 2.85-2.85h5.7A2.85 2.85 0 0 0 17.6 19a2.85 2.85 0 0 0 2.85-2.85h1.9v-3.8c0-1.054-.846-1.9-1.9-1.9l-2.85-3.8H3.35m11.4 1.425h2.375l1.862 2.375H14.75V8.075m-8.55 6.65a1.425 1.425 0 0 1 1.425 1.425A1.425 1.425 0 0 1 6.2 17.575a1.425 1.425 0 0 1-1.425-1.425A1.425 1.425 0 0 1 6.2 14.725m11.4 0a1.425 1.425 0 0 1 1.425 1.425 1.425 1.425 0 0 1-1.425 1.425 1.425 1.425 0 0 1-1.425-1.425 1.425 1.425 0 0 1 1.425-1.425Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBlueVan);
export default __webpack_public_path__ + "static/media/OurBlueVan.aabab0f234a9f7c894dfba8eb2032ec9.svg";
export { ForwardRef as ReactComponent };